module.exports = __webpack_public_path__ + "img/tips-for-households.659f01e.png";